import { createI18n } from 'vue-i18n/index';
import $en from '@/i18nPlugin/locales/en';
import $mm from '@/i18nPlugin/locales/mm';
import store from "@/store/index";



export const availableLanguages = [
    {
        title: 'English',
        code: 'en'
    },
    {
        title: 'Myanmar',
        code: 'mm'
    }
]

const messages = {
    en: $en,
    mm: $mm,
}

export const i18n = createI18n({
    // TODO: make the default language english but overridable via ENV Or local storage
    locale: store.state.lang || process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages,
    globalInjection: true,
    legacy: false,
})
